import { style } from "@vanilla-extract/css";
import { globalStyle } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

/**
 * AG Charts zoom buttons global style override.
 * Centers the zoom buttons and sets a fixed width.
 * This fixes a bug where the default 100% width blocks tooltips and other interactions.
 */
globalStyle(".ag-charts-zoom-buttons", {
  width: "150px !important",
  justifySelf: "center",
  padding: "0px"
});
/**
 * Styles for the loading overlay in ag-Grid charts.
 */

export const noData = style({
  color: semanticThemeTokens.chart.textColor,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  alignContent: "center",
  fontWeight: 600,
  fontSize: primitiveTokens.type.xs,
  height: "100%",
  width: "100%"
});

export const chartRoot = style({
  height: "100%",
  display: "grid"
});

globalStyle(`.ag-charts-tooltip`, {
  border: `1px solid ${semanticThemeTokens.chart.borderColour}`,
  background: semanticThemeTokens.chart.tooltipBackground,
  color: semanticThemeTokens.chart.tooltipTextColor
});

globalStyle(`.ag-charts-tooltip > *`, {
  paddingRight: `${primitiveTokens.sizing["4x"]}`,
  paddingLeft: `${primitiveTokens.sizing["4x"]}`
});
